'use strict';

var _ = require('lodash');
var OnlineLogitCalibrationGridController = function OnlineLogitCalibrationGridController($scope, $rootScope, $filter, calibrationAnalysisConstants, configurationService, userPreferencesService, dataRetrieverConstants, onlineLogitCalibrationCSVService, logitSharesDataTransformationService, logitSharesNormalizationService) {
  $scope.gridId = dataRetrieverConstants.ONLINE_LOGIT_CALIBRATION_GRID;
  $scope.mode = dataRetrieverConstants.ONLINE_LOGIT_CALIBRATION_MODE;
  $scope.gridDataReady = false;
  var readingTimeRegex = /(-?\d+)d \d+h \d+m/;
  var rmNumberFormat = $filter('rmNumberFormat');
  var gridExpansionState = userPreferencesService.getUserSettingComponent('onlineLogitCalibrationExpansion');
  $scope.screenState.isOnlineLogitGridExpanded = gridExpansionState ? gridExpansionState : false;
  $scope.computeScenarioName = function () {
    $scope.screenState.scenarioName = _.isUndefined($scope.selectedCalibrationData.assigned) ? _.join(['AVRO', $scope.selectedCalibrationData.calibrationName, $scope.selectedCalibrationData.market], '-') : calibrationAnalysisConstants.SCENARIO_NAME_PUBLISHED;
    $scope.screenState.calibrationName = $scope.selectedCalibrationData.active === calibrationAnalysisConstants.CALIBRATION_STATUSES.INACTIVE ? $scope.selectedCalibrationData.calibrationName : '';
  };
  $scope.toggleExpandCollapseGrid = function () {
    $scope.screenState.isOnlineLogitGridExpanded = !$scope.screenState.isOnlineLogitGridExpanded;
  };
  $scope.prepareDataForGrid = function () {
    $scope.transformedData = logitSharesDataTransformationService.transformLogitDataForGrid($scope.logitData, $scope.maxRtp);
    $scope.gridDataReady = true;
  };
  $scope.userShareEditHandler = function (gridData, rowId, dataField) {
    var rowData = gridData[rowId];
    if (isUpdateInvalid(rowData, dataField)) {
      return;
    }
    var logitParam = getImpactedLogitParams(rowData.key, rowData.readingTime);
    if (rowData.type !== calibrationAnalysisConstants.CHART_TYPES.TIME_OF_DAY) {
      extractImpactedRows(rowData.userShare, gridData, rowData);
      if (rowData.type === calibrationAnalysisConstants.CHART_TYPES.FARE) {
        logitParam.userRelativeFareLogit = rowData.userShare;
      } else {
        logitParam.userElapsedTimeLogit = rowData.userShare;
      }
      $rootScope.$broadcast('online-logit-calibration:grid-data-updated', rowData.key, rowData.type, rowData.readingTime, rowData.userShare);
    } else {
      normalizeTimeOfDayShares(logitParam, rowData);
      extractImpactedRows(logitParam, gridData, rowData);
    }
    $scope.$emit('online-logit-calibration:updated-logit-shares', _.join([rowData.key, rowData.type], '.'));
  };
  function getImpactedLogitParams(hepKey, expectedReadingTime) {
    return _.chain($scope.logitData).find(function (profile) {
      return profile.hepKey === hepKey;
    }).get('properties.logitParams').filter(function (param) {
      var readingTime = _.toNumber(param.startReadingTimeInterval.match(readingTimeRegex)[1]);
      return readingTime === expectedReadingTime;
    }).first().value();
  }
  function normalizeTimeOfDayShares(logitParams, rowData) {
    var timeOfDayPreferences = logitParams.logitTimeOfDayPreferences;
    var impactedTimeOfDay = _.find(timeOfDayPreferences, {
      timeOfDayStart: rowData.timeOfDay
    });
    impactedTimeOfDay.userShare = rowData.userShare;
    logitSharesNormalizationService.normalizeShares(timeOfDayPreferences, rowData.type);
    $rootScope.$broadcast('online-logit-calibration:grid-data-updated', rowData.key, rowData.type, rowData.readingTime, timeOfDayPreferences);
  }
  function extractImpactedRows(logitParam, gridData, rowData) {
    var overridesData = _.filter(gridData, function (row) {
      return row.key === rowData.key && row.readingTime === rowData.readingTime && row.type === rowData.type;
    });
    if (_.isObject(logitParam)) {
      _.map(overridesData, function (override) {
        var timeOfDayPreferences = logitParam.logitTimeOfDayPreferences;
        var impactedTimeOfDay = _.find(timeOfDayPreferences, {
          timeOfDayStart: override.timeOfDay
        });
        override.effectiveShare = rmNumberFormat(impactedTimeOfDay.effectiveShare, 'NUMBER');
        impactedTimeOfDay.userTimeOfDayPreferenceCoefficient = _.isNull(override.userShare) ? null : _.toNumber(override.userShare);
        override.customClasses = {
          effectiveShare: 'normalized'
        };
        return override;
      });
    } else {
      var data = overridesData[0];
      data.effectiveShare = _.isNull(logitParam) ? rmNumberFormat(data.modelShare, 'NUMBER_LOGIT') : rmNumberFormat(logitParam, 'NUMBER_LOGIT');
      data.customClasses = {
        'effectiveShare': 'normalized'
      };
    }
    $scope.$broadcast('grid:getRowsByKeyColumns', $scope.gridId, overridesData);
  }
  $scope.updateGridColumns = function (event, gridRowData, actualOverrides) {
    var columnUpdates = _.reduce(gridRowData, function (values, row) {
      var impactedRowData = row.rowData;
      if (!_.isUndefined(actualOverrides)) {
        impactedRowData = _.find(actualOverrides, function (override) {
          return override.key === impactedRowData.key && override.readingTime === impactedRowData.readingTime && override.type === impactedRowData.type && override.timeOfDay === impactedRowData.timeOfDay;
        });
      }
      var userShare = {
        rowId: row.rowId,
        columnName: 'userShare',
        value: impactedRowData.userShare,
        oldValue: null,
        customClasses: _.isNil(impactedRowData.customClasses) ? undefined : impactedRowData.customClasses.userShare
      };
      var effectiveShare = {
        rowId: row.rowId,
        columnName: 'effectiveShare',
        value: impactedRowData.effectiveShare,
        oldValue: null,
        customClasses: _.isNil(impactedRowData.customClasses) ? undefined : impactedRowData.customClasses.effectiveShare
      };
      return values.concat(userShare, effectiveShare);
    }, []);
    $scope.$broadcast('grid:setMultipleCellsValue', $scope.gridId, columnUpdates, true);
  };
  $scope.syncGridWithChartUpdates = function (event, overrides) {
    logitSharesDataTransformationService.updateLogitProfile(overrides, $scope.logitData);
    $scope.$broadcast('grid:getRowsByKeyColumns', $scope.gridId, overrides, overrides);
  };
  function isUpdateInvalid(rowData, dataField) {
    return dataField !== 'userShare' || _.isNil(rowData) || _.isNil(rowData._old) || _.isEqual(rowData._old.userShare, rowData.userShare);
  }
  $scope.makeExportToCsv = function (visibleRows) {
    onlineLogitCalibrationCSVService.exportToCSV(visibleRows);
  };
  $scope.getUpdates = function (event, updateKeys, publishIndicator) {
    var profiles = _.chain(updateKeys).map(function (key) {
      return _.find($scope.logitData, {
        hepKey: key
      });
    }).value();
    $scope.$emit('online-logit-calibration:profile-updates', profiles, publishIndicator);
  };
};
OnlineLogitCalibrationGridController.$inject = ['$scope', '$rootScope', '$filter', 'CalibrationAnalysisConstants', 'ConfigurationService', 'UserPreferencesService', 'DataRetrieverConstantsService', 'OnlineLogitCalibrationCSVService', 'LogitSharesDataTransformationService', 'LogitSharesNormalizationService'];
module.exports = OnlineLogitCalibrationGridController;